<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><i>Dedicated to the Grand Rapids Civil War Round Table</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?41e9ba26